import { z } from "zod";

export const termsAndConditionsUploadSchema = z.object({
  file: z
    .any()
    .refine((files) => files?.length > 0, "File is required")
    .refine(
      (files) => files?.[0]?.size <= 50 * 1024 * 1024,
      "File size must be less than 50MB"
    )
    .refine((files) => {
      const file = files?.[0];
      if (!file) return false;
      const isPdfMime = file.type === "application/pdf";
      const isPdfExt = typeof file.name === "string" && file.name.toLowerCase().endsWith(".pdf");
      return isPdfMime || isPdfExt;
    }, "Only PDF files are allowed"),
});

export type TermsAndConditionsFormData = z.infer<
  typeof termsAndConditionsUploadSchema
>;

export interface TermsAndConditions {
  id: string;
  tenantId: string;
  fileName: string;
  fileUrl: string;
  version: number;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
  createdBy?: string;
}

export interface TermsAndConditionsResult {
  termsAndConditions: TermsAndConditions[];
  page: number;
  pageSize: number;
  total: number;
  totalPages: number;
  hasNextPage: boolean;
  hasPrevPage: boolean;
}

export interface TermsAndConditionsFilters {
  page?: number;
  pageSize?: number;
}

export interface TermsAndConditionsRequest {
  file: File;
}

